export enum MessageType {
  primary = 'primary',
  secondary = 'secondary',
  warning = 'warning',
  danger = 'danger',
  info = 'info',
  light = 'light',
  dark = 'dark',
  success = 'success'
}

export enum TransitionType {
  none = 'none',
  fade = 'fade',
  slide = 'slide',
  slide_right = 'slide-right',
  slide_left = 'slide-left',
  zoom = 'zoom'
}

export enum SortType {
  none = 'none',
  desc = 'desc',
  asc = 'asc'
}

export enum LessonType {
  SUMMARY = 'SUMMARY',
  READING = 'READING',
  LISTENING = 'LISTENING',
  WRITING = 'WRITING',
  SPEAKING = 'SPEAKING'
}

export enum PracticeType {
  ANSWER_FORMAT_SELECT_AN_ANSWER = 'select-an-answer',
  ANSWER_FORMAT_SHORT_FREE_TEXT = 'short-free-text',
  ANSWER_FORMAT_LONG_FREE_TEXT = 'long-free-text',
  ANSWER_FORMAT_AUDIO_INPUT = 'audio-input'
}

export enum ROLE {
  Administrator = 'Administrator',
  Manager = 'Manager'
}
